var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCeusaHw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#F4F4F5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.35,23.48A12.71,12.71,0,0,1,16,10.75h.09a12.34,12.34,0,0,1,12.1,8.34H24.08c-1.43-3-4.19-4.59-7.94-4.59a9,9,0,0,0,0,18c3.7,0,6.51-1.38,7.94-4.54h4.15a12.35,12.35,0,0,1-12.1,8.29A12.71,12.71,0,0,1,3.35,23.57v-.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.31,25.31h-21c.35,4.49,4.34,7.2,9,7.2,3.16,0,5.83-1.08,7.3-3h4c-1.82,4.19-6.32,6.76-11.4,6.76-7.31,0-12.93-5.14-12.93-12.39a11,11,0,0,1,.15-2h21A8.21,8.21,0,0,0,44,14.45a8.36,8.36,0,0,0-7.94,4.64H32a12.79,12.79,0,0,1,12.09-8.34c6.81,0,12.29,6,12.29,12.73a16,16,0,0,1-.1,1.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.84,25.26v-14h3.8V25.21c0,4.64,2.82,7.4,7.36,7.4s7.35-2.76,7.35-7.4V11.29h3.8v14c0,6.81-4.83,11-11.15,11s-11.16-4.15-11.16-11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.79,33.5V29.26A16.71,16.71,0,0,0,98,32.61c2.86,0,6-.49,6-3.65,0-2.52-2.67-3.45-6.57-3.85-5.27-.54-9.62-2.22-9.62-7.25,0-5.38,4.89-7.11,9.77-7.11a15,15,0,0,1,8.1,2v3.9a14.88,14.88,0,0,0-8.1-2.27c-3.45,0-5.62.94-5.62,3.46s2.37,3.3,5.67,3.65c5.48.54,10.12,1.82,10.12,7.65,0,4.64-4.39,7.16-10.17,7.16-2.86,0-6.91-.7-9.77-2.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M132.85,23.48a8.76,8.76,0,0,0-8.49-9h-.54a9,9,0,1,0,9,9m-22,0a12.69,12.69,0,0,1,12.58-12.73,11.57,11.57,0,0,1,9.43,4.44v-3.9h3.75V35.67H132.9v-3.9a11.57,11.57,0,0,1-9.43,4.44,12.69,12.69,0,0,1-12.58-12.73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCeusaHw);
export default __webpack_public_path__ + "static/media/logo-ceusa-hw.9049c3e63fd66c7b0a1680a65e7af5d3.svg";
export { ForwardRef as ReactComponent };